import { queryOptions } from '@tanstack/react-query';

import { referralApi } from './referral.api';

export const queryKeys = {
    all: ['referral'] as const,
    link: () => [...queryKeys.all, 'link'] as const,
};

export function referralLinkOptions(enabled = true) {
    return queryOptions({
        queryKey: queryKeys.link(),
        queryFn: ({ signal }) => referralApi.getLink(signal),
        staleTime: 0,
        enabled,
    });
}
